// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#app[data-v-e986b55a]{min-height:100vh}\n", "",{"version":3,"sources":["/app/app/javascript/packs/frontend/App.vue"],"names":[],"mappings":"AAyFA,sBAEI,gBAAiB","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// グローバルスタイルを設定\n#app {\n    /*background-color: whitesmoke;*/\n    min-height: 100vh;\n}\n\n"]}]);
// Exports
module.exports = exports;
